
/* Desktop header: hides while scrolling down, slides back in on scroll up
   (in the style of moncler.com). Desktop only (1068px and wider).
   States on <html>:
     (none)            header sits in the page as normal (top of the page)
     alhaq-hdr--away   header pinned above the screen, out of sight
     alhaq-hdr--shown  header pinned at the top, solid cream
   The switch between "in the page" and "pinned" only happens where both
   positions line up, so nothing jumps. */
(function () {
  var root = document.documentElement;
  var section = document.querySelector('.header-section');
  var header = document.getElementById('header');
  if (!section || !header) return;
  var mq = window.matchMedia('(min-width: 1068px)');
  var state = 'top';
  var lastY = window.scrollY;
  var travel = 0;            // distance scrolled in the current direction
  var ticking = false;
  var NUDGE = 6;             // px of scroll before the header reacts

  function sectionTop() {
    // Where the header sits in the page when it isn't pinned
    return section.getBoundingClientRect().top + window.scrollY;
  }
  function headerHeight() { return header.offsetHeight; }

  function set(next, animate) {
    if (next === state) return;
    var h = headerHeight();
    root.style.setProperty('--alhaq-hdr-h', h + 'px');
    header.style.top = '';
    if (next === 'top') {
      root.classList.remove('alhaq-hdr--away', 'alhaq-hdr--shown', 'alhaq-hdr--anim');
      section.style.minHeight = '';
      header.classList.remove('is-sticky');
    } else {
      // Hold the header's space in the page so content doesn't jump up
      if (!header.classList.contains('transparent--true')) section.style.minHeight = h + 'px';
      root.classList.toggle('alhaq-hdr--anim', !!animate);
      root.classList.toggle('alhaq-hdr--away', next === 'away');
      root.classList.toggle('alhaq-hdr--shown', next === 'shown');
      if (next === 'shown') header.classList.add('is-sticky');
      else if (animate) {
        // Keep the cream background while it slides out
        setTimeout(function () { if (state === 'away') header.classList.remove('is-sticky'); }, 420);
      } else header.classList.remove('is-sticky');
    }
    state = next;
  }

  function update() {
    ticking = false;
    var y = window.scrollY;
    var dy = y - lastY;
    lastY = y;
    if (!mq.matches || document.body.classList.contains('open-cc')) {
      if (!mq.matches) set('top');
      return;
    }
    var top = sectionTop();
    var h = headerHeight();

    if (dy === 0) return;
    travel = (dy > 0) === (travel > 0) ? travel + dy : dy;

    if (y <= top) {
      // Near the very top while the header is showing: keep it pinned but
      // let it ride down with the page until it's back in its usual place
      if (state === 'shown' && y > 0) { header.style.top = (top - y) + 'px'; return; }
      set('top');
      return;
    }
    if (header.style.top) header.style.top = '';

    if (state === 'top') {
      // Pin it out of sight once it has scrolled fully off the screen
      if (y >= top + h) set('away', false);
      return;
    }
    if (state === 'away' && travel <= -NUDGE) set('shown', true);
    else if (state === 'shown' && travel >= NUDGE) set('away', true);
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', function () {
    if (!mq.matches) set('top');
    else if (state !== 'top') root.style.setProperty('--alhaq-hdr-h', headerHeight() + 'px');
  });
  update();
})();
